import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import NavigationBarApply from './NavigationBarApply';
import NavigationBarClean from './NavigationBarClean';
import useApplyNewStore from '../../store/useApplyNewStore';
import { basename } from '../../setting';

function NavigationBar({ ...props }) {
  const { step } = useApplyNewStore();
  const location = useLocation();

  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = () => {
    if (typeof window !== 'undefined') {
      const scrollY = window.scrollY;

      if (scrollY < 30) {
        setIsVisible(true);
      } else if (scrollY + window.innerHeight >= document.documentElement.scrollHeight - 30) {
        setIsVisible(false);
      } else if (scrollY > lastScrollY && isVisible) {
        // Show header when scrolling up, hide it when scrolling down
        setIsVisible(false); // Hide when scrolling down
      } else if (scrollY < lastScrollY && !isVisible) {
        setIsVisible(true); // Show when scrolling up
      }

      setLastScrollY(scrollY);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY, isVisible]);


  // Apply page
  return (
    <Container $isVisible={isVisible}>
      {
        (
          step === "1" ||
          step === "2" ||
          step === "3" ||
          step === "4"
        ) &&
        <NavigationBarApply />
      }

      {
        (
          step === "loading" ||
          step === "0" ||
          step === "success" ||
          step === "paymentFail" ||
          step === "submitFail"
        ) &&
        <NavigationBarClean />
      }
    </Container>
  );
}

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0%;
  transform: translateX(-50%);
  width: 100%;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
  height: 5rem;
  z-index: 500;

  transition: transform 0.3s ease;
  ${props => props.$isVisible ? `transform: translateY(0);` : `transform: translateY(-100%);`}
`;

export default NavigationBar;